import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from 'environments/environment';

@Injectable()
export class BannersService {
    banners: any = [];
    ipAddress: any = '';
    intoBuildings: any = [];

    constructor(private http: Http) {
        this.getIP();
    }

    getBuildings() {
        this.intoBuildings = [];
        const userData = JSON.parse(localStorage.getItem('userData'));
        const buildingPropertyManager = userData.buildingPropertyManager;
        buildingPropertyManager.forEach(element => this.intoBuildings.push(element.buildingId));
        return this.intoBuildings;
    }

    getBanners(data: object) {
        return new Promise((resolve, reject) => {
            this.http
                .post(`${environment.oauthUrl}/banners/requestClient`, data)
                .subscribe(
                    res => {
                        const body = res['_body'];
                        const entities = JSON.parse(body);
                        this.banners = entities.result;
                        resolve(this.banners);
                    },
                    err => {
                        reject(err);
                    }
                );
        });
    }
    getBannerUrl(data: object) {
        return new Promise((resolve, reject) => {
            this.http
                .post(`${environment.oauthUrl}/banners/getBannerUrl`, data)
                .subscribe(
                    res => {
                        let body = res['_body'];
                        const entities = JSON.parse(body);
                        const url = entities.result.url;
                        resolve(url);
                    },
                    err => {
                        reject(err);
                    }
                );
        });
    }

    getIP() {
        return new Promise((resolve, reject) => {
            this.http.get('https://jsonip.com').subscribe(
                response => {
                    const entities = response['_body'] || [];
                    const data = JSON.parse(entities);
                    this.ipAddress = data.ip;
                    resolve();
                },
                err => {
                    reject(err);
                }
            );
        });
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/banners.service.ts